import React from "react";
import { Link } from "react-scroll";

export const NavbarListMobile = ({ sectionName, handleClick }) => {
  return (
    <li className="py-6 text-4xl capitalize">
      <Link
        to={sectionName}
        smooth={true}
        duration={500}
        onClick={() => handleClick()}
      >
        {sectionName}
      </Link>
    </li>
  );
};
